var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import * as React from 'react';
import supportedLanguages from 'app/utils/supportedLanguages';
import styles from './templateLanguagesCell.module.scss';
export const TemplateLanguagesCell = (_a) => {
    var { translations, className } = _a, restProps = __rest(_a, ["translations", "className"]);
    const locales = Object.keys(translations || {});
    if (!locales.length) {
        return null;
    }
    const languages = supportedLanguages
        .filter((language) => locales.includes(language.code))
        .map((language) => language.label);
    const languagesString = languages.join(', ');
    const rootClass = classnames(styles.root, className);
    return (_jsx(Tooltip, Object.assign({ dark: true, content: languagesString }, { children: _jsxs("div", Object.assign({ className: rootClass }, restProps, { children: [_jsx("div", Object.assign({ className: styles.languages }, { children: languagesString })), _jsxs("div", Object.assign({ className: styles.total }, { children: ["(", locales.length, ")"] }))] })) })));
};
